import {
  Flex,
  FormControl,
  FormLabel,
  Input,
  Select,
  Button,
  Text,
  InputRightElement,
  InputGroup,
  FormErrorMessage,
  useToast,
  Stack,
  Box,
  CheckboxGroup,
  Checkbox,
  Textarea,
} from "@chakra-ui/core";
import React from "react";
import { Layout } from "../layouts/Layout";
import { useForm } from "react-hook-form";
import { updateProfile } from "../api/user.service";
import useAuth from "../context/AuthContext";
import jwtService from "../api/jwt.service";
import { useHistory, useLocation } from "react-router";
import { getJobCertifications, getJobSectors } from "../api/jobs.service";
import { citiesRegions } from "../lib/utils/mock";

const CreateProfilePage = () => {
  const { register, errors, formState, handleSubmit } = useForm();
  const [languages, setLanguages] = React.useState([]);
  const [jobCertifications, setJobCertifications] = React.useState([]);
  const [jobSectors, setJobSectors] = React.useState([]);
  const [region, setRegion] = React.useState("");
  const [districts, setDistrict] = React.useState([]);
  const [district, setSelectedDistrict] = React.useState("");

  const user = JSON.parse(jwtService.getItem("user"));

  const toast = useToast();
  const history = useHistory();
  const { pathname } = useLocation();

  const { dispatch } = useAuth();

  function useQuery() {
    return new URLSearchParams(useLocation().search);
  }
  const query = useQuery();
  const hasProfile = query.get("hasProfile");
  const prevLocation = query.get("prevLocation");
  const role = query.get("role");

  const fetchJobCertifications = async () => {
    try {
      const { data } = await getJobCertifications();

      const transformedJobCertifications =
        data &&
        data.data?.map((jobCertification) => {
          return {
            job_certification_id: jobCertification.id,
            job_certification: jobCertification.name,
          };
        });

      setJobCertifications(transformedJobCertifications);
    } catch (error) {
      console.log(error);
    }
  };

  const fetchJobSectors = async () => {
    try {
      const { data } = await getJobSectors();

      const transformedJobSectors =
        data &&
        data.data?.map((jobSector) => {
          return {
            job_sector_id: jobSector.id,
            job_sector: jobSector.name,
          };
        });

      setJobSectors(transformedJobSectors);
    } catch (error) {
      console.log(error);
    }
  };

  const regions = Object.keys(citiesRegions).map((key) => {
    return {
      label: key,
      value: key,
    };
  });

  const handleSelectRegion = (value) => {
    setRegion(value);
    checkDistrict(value);
  };

  const checkDistrict = (value) => {
    switch (value) {
      case value:
        setDistrict(citiesRegions[value]);
        break;
      default:
        break;
    }
  };

  React.useEffect(() => {
    hasProfile === "false" &&
      toast({
        title: "Profile SetUp",
        description: "You need to set up your profile to continue",
        position: "top",
        duration: 2500,
        isClosable: true,
      });
    fetchJobCertifications();
    fetchJobSectors();
  }, []);

  const onSubmitHandler = async (values) => {
    try {
      const profileData = { ...values, languages };
      const { data } = await updateProfile(profileData);
      jwtService.storeItem(
        JSON.stringify({ ...user, hasProfile: true }),
        "user"
      );
      data && dispatch("SET_HAS_PROFILE");
      dispatch({
        type: "LOAD_USER",
        user: { ...user, hasProfile: true },
      });
      if (hasProfile === null) {
        history.push("/dashboard");
        toast({
          title: "Profile Setup",
          description: "Profile has been set up successfully",
          position: "top",
          isClosable: true,
          duration: 2500,
        });
        return;
      }

      !pathname.includes("/dashboard")
        ? history.push("/application/oye?apply=oye")
        : prevLocation
        ? history.push(prevLocation)
        : history.push("/dashboard/application/oye?apply=oye");

      toast({
        title: "Profile Setup",
        description: "Profile has been set up successfully",
        position: "top",
        isClosable: true,
        duration: 2500,
      });
    } catch (error) {
      console.log("Err", error);
    }
  };

  const langOptions = ["Twi", "Nzemaa", "French", "Fantse", "English"];

  return (
    <Layout hide={pathname.includes("/dashboard")} title='Create Profile'>
      <Box
        my={pathname.includes("/dashboard") ? ["10", "10"] : ["160px", "200px"]}
      >
        <Text textAlign='center' fontSize={["xl", "3xl"]} fontWeight='700'>
          Let's set up your profile for you
        </Text>
        <Box
          w={["95%", "80%"]}
          shadow='lg'
          p={pathname.includes("/dashboard") ? ["4", "10"] : ["8", "20"]}
          mx='auto'
          mt='8'
        >
          <form onSubmit={handleSubmit(onSubmitHandler)}>
            <FormControl mt='20px' isInvalid={errors.about} flex='1' w='100%'>
              <FormLabel htmlFor='about'>About</FormLabel>
              <Textarea
                type='text'
                placeholder='Tell us about yourself'
                name='about'
                ref={register}
              ></Textarea>
              <FormErrorMessage>
                {errors.about && errors.about.message}
              </FormErrorMessage>
            </FormControl>
            <Flex direction={["column", "row"]}>
              <FormControl mb='6' mr={["0", "2"]} flex='1' isRequired>
                <FormLabel htmlFor='nationality' isInvalid={errors.nationality}>
                  Nationality
                </FormLabel>
                <Input type='text' name='nationality' ref={register}></Input>
                <FormErrorMessage>
                  {errors.nationality && errors.nationality.message}
                </FormErrorMessage>
              </FormControl>
              <FormControl mb='6' mr={["0", "2"]} flex='1' isRequired>
                <FormLabel
                  htmlFor='date_of_birth'
                  isInvalid={errors.date_of_birth}
                >
                  Date of Birth
                </FormLabel>
                <Input
                  type='date'
                  name='date_of_birth'
                  ref={register({ required: "Field is required" })}
                ></Input>
                <FormErrorMessage>
                  {errors.date_of_birth && errors.date_of_birth.message}
                </FormErrorMessage>
              </FormControl>
            </Flex>
            <Flex w='100%'>
              <FormControl mt='20px' isInvalid={errors.region} flex='1' w='50%'>
                <FormLabel htmlFor='region'>Region</FormLabel>
                <Select
                  type='text'
                  placeholder='Select Region'
                  name='region'
                  ref={register}
                  onChange={(e) => handleSelectRegion(e.target.value)}
                >
                  {regions.map((region) => {
                    return (
                      <option value={region.value} key={region.value}>
                        {region.label}
                      </option>
                    );
                  })}
                </Select>
                <FormErrorMessage>
                  {errors.region && errors.region.message}
                </FormErrorMessage>
              </FormControl>
              <FormControl w='50%' mt='20px' flex='1' isRequired>
                <FormLabel htmlFor='city'>City</FormLabel>
                <Select
                  type='text'
                  placeholder='Select District/City'
                  name='city'
                  ref={register}
                  onChange={(e) => setSelectedDistrict(e.target.value)}
                >
                  {districts.map((district) => {
                    return (
                      <option value={district} key={district}>
                        {district}
                      </option>
                    );
                  })}
                </Select>
                <FormErrorMessage>
                  {errors.city && errors.city.message}
                </FormErrorMessage>
              </FormControl>
            </Flex>
            <Flex
              justify={["start", "space-between"]}
              direction={["column", "row"]}
            >
              <FormControl
                mb='6'
                flex='1'
                isRequired
                isInvalid={errors.postal_address}
                mr={["0", "2"]}
              >
                <FormLabel htmlFor='postal_address'>Postal Address</FormLabel>
                <Input
                  type='text'
                  placeholder='E.g P.O Box 234'
                  name='postal_address'
                  ref={register}
                ></Input>
                <FormErrorMessage>
                  {errors.postal_address && errors.postal_address.message}
                </FormErrorMessage>
              </FormControl>
              <FormControl
                mb='6'
                isInvalid={errors.residential_address}
                flex='1'
              >
                <FormLabel htmlFor='residential_address'>
                  Residential Address
                </FormLabel>
                <Input
                  type='text'
                  placeholder='Residential Address'
                  name='residential_address'
                  ref={register}
                ></Input>
                <FormErrorMessage>
                  {errors.residential_address &&
                    errors.residential_address.message}
                </FormErrorMessage>
              </FormControl>
            </Flex>
            {/* <FormControl flex='1' mb='6' w={["100%", "50%"]}>
              <FormLabel>Phone Number</FormLabel>
              <Input type='text' name='phone_number' ref={register}></Input>
            </FormControl> */}
            <Flex
              justify={["start", "space-between"]}
              direction={["column", "row"]}
            >
              <FormControl
                flex='1'
                mr={["0", "2"]}
                mb='6'
                isInvalid={errors.languages}
              >
                <FormLabel>Languages</FormLabel>
                <CheckboxGroup
                  colorScheme='green'
                  name='languages'
                  onChange={(values) => setLanguages(values)}
                >
                  <Stack
                    isInline
                    spacing='4'
                    align='center'
                    mt='2'
                    flexWrap={["wrap", "nowrap"]}
                  >
                    {langOptions.map((option, index) => (
                      <Checkbox value={option} key={index}>
                        {option}
                      </Checkbox>
                    ))}
                  </Stack>
                </CheckboxGroup>
              </FormControl>
            </Flex>
            <Stack isInline>
              <FormControl w='50%'>
                <FormLabel>Certification</FormLabel>
                <Select
                  placeholder='Select Job Certifcation'
                  ref={register}
                  name='job_certification_id'
                  defaultValue=''
                >
                  {jobCertifications.map((certifications) => (
                    <option
                      value={certifications.job_certification_id}
                      key={certifications.job_certification_id}
                    >
                      {certifications.job_certification}
                    </option>
                  ))}
                </Select>
              </FormControl>
              <FormControl w='50%'>
                <FormLabel>Job Sector</FormLabel>
                <Select
                  // placeholder={job.job_sector?.name}
                  ref={register}
                  name='job_sector_id'
                  defaultValue=''
                >
                  {jobSectors.map((sector) => (
                    <option
                      value={sector.job_sector_id}
                      key={sector.job_sector_id}
                    >
                      {sector.job_sector}
                    </option>
                  ))}
                </Select>
              </FormControl>
            </Stack>
            <Flex justify='space-between' align='flex-end'>
              <Button
                type='submit'
                variantColor='green'
                rightIcon='arrow-forward'
                my='4'
                isLoading={formState.isSubmitting}
              >
                Create Profile
              </Button>
            </Flex>
          </form>
        </Box>
      </Box>
    </Layout>
  );
};

export default CreateProfilePage;
